"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restartProcessingOutcomeSchema = exports.RestartProcessingOutcome = void 0;
const z = require("zod");
var RestartProcessingOutcome;
(function (RestartProcessingOutcome) {
    RestartProcessingOutcome["Started"] = "started";
    RestartProcessingOutcome["AlreadyRunning"] = "already_running";
})(RestartProcessingOutcome || (exports.RestartProcessingOutcome = RestartProcessingOutcome = {}));
exports.restartProcessingOutcomeSchema = z.nativeEnum(RestartProcessingOutcome);
//# sourceMappingURL=restart-processing-outcome.js.map